import { kaapApiRef, useAzureToken } from '@internal/backstage-plugin-kaap';
import { useAsyncFn } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';

export const useGetTenants = () => {
  const kaapApi = useApi(kaapApiRef);
  const { getToken } = useAzureToken();

  return useAsyncFn(async () => {
    const { token } = await getToken();
    return kaapApi.getTenants(token);
  });
};
